import { createChannel, createContext } from "effection";
export const StoreUpdateContext = createContext("starfx:store:update", createChannel());
export const StoreContext = createContext("starfx:store");
